import { AdminClassroomLayout } from "@/pages/admin/AdminClassroomLayout";
import { AdminClassroomsPage } from "@/pages/admin/AdminClassroomsPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/classrooms/")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <AdminClassroomLayout>
      <AdminClassroomsPage />
    </AdminClassroomLayout>
  );
}
